export default __webpack_public_path__ + "static/media/aerial.1f28045d.png";